export default "__VITE_ASSET__CMl1d_KF__"